/**
 * Build-target helper — reads REACT_APP_BUILD_TARGET at build time.
 *
 * Values:
 *   • 'web' (default) — full public website; all marketing surfaces render.
 *   • 'app'           — TWA / Capacitor bundle for Play / App Store. Hides
 *                       masjid-poster distribution, knowledge poster gallery,
 *                       share/invite CTAs and copy-localised-link so the
 *                       store-submitted binary contains no external
 *                       web-marketing surfaces (App Store Guideline 4.2).
 *
 * Usage:
 *   import { isAppBuild } from '../utils/buildTarget';
 *   {isAppBuild ? null : <MasjidPosterSection />}
 */
export const BUILD_TARGET = (process.env.REACT_APP_BUILD_TARGET || 'web').toLowerCase();
export const isAppBuild = BUILD_TARGET === 'app';
export const isWebBuild = !isAppBuild;
